/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_EVENT_TEMPLATE_TYPES,
  GET_EVENT_TEMPLATE_TYPES_SUCCESS,
  GET_EVENT_TEMPLATE_TYPES_ERROR,
} from 'src/actions/eventTemplateTypesActions';

// CON-1518 — Event Template Types registry slice.
//
// Loaded once after login. Consumers (template list view, detail
// view, admin list view) read via selectors in
// src/selectors/eventTemplateTypesSelectors.js.

const initialState = {
  loading: false,
  loaded: false,
  byType: {}, // map: templateType string → registry row
  list: [], // ordered array (by sortOrder ASC, as returned by API)
  error: null,
};

const eventTemplateTypesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EVENT_TEMPLATE_TYPES: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.error = null;
      });
    }

    case GET_EVENT_TEMPLATE_TYPES_SUCCESS: {
      return produce(state, (draft) => {
        const list = Array.isArray(payload?.eventTemplateTypes)
          ? payload.eventTemplateTypes
          : [];
        draft.loading = false;
        draft.loaded = true;
        draft.list = list;
        draft.byType = Object.fromEntries(list.map((row) => [row.templateType, row]));
        draft.error = null;
      });
    }

    case GET_EVENT_TEMPLATE_TYPES_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        // Mark loaded even on failure so the list view resolves to a
        // loaded/empty state instead of hanging its spinner forever.
        draft.loaded = true;
        draft.error = payload?.error || 'Failed to load event template types';
      });
    }

    default:
      return state;
  }
};

export default eventTemplateTypesReducer;
